import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'colControl',
  data: function data() {
    return {
      colData: {},
      selectList: [],
      checkAll: {},
      selectCol: [],
      firstState: true
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: []
    }
  },
  watch: {
    options: {
      handler: function handler(val) {
        var _this = this;

        if (val && val.length > 0) {
          console.log('options', val); // 拆分分组

          this.colData = {};

          if (this.firstState) {
            this.selectCol = [];
            this.checkAll = {};
          }

          if (val.length > 15) {
            val.forEach(function (item) {
              if (!_this.colData[item.categoryName]) {
                _this.colData[item.categoryName] = [_objectSpread({}, item)];
              } else {
                _this.colData[item.categoryName].push(_objectSpread({}, item));
              }
            });

            if (this.firstState) {
              this.selectCol = this.colData[val[0].categoryName].map(function (v) {
                return v.value;
              });
              this.checkAll[val[0].categoryName] = true;
            }
          } else {
            val.forEach(function (item) {
              if (_this.firstState) {
                _this.selectCol.push(item.value);
              }

              if (!_this.colData[item.categoryName]) {
                _this.colData[item.categoryName] = [_objectSpread({}, item)];

                if (_this.firstState) {
                  _this.checkAll[item.categoryName] = true;
                }
              } else {
                _this.colData[item.categoryName].push(_objectSpread({}, item));
              }
            });
          }

          this.$emit('onChange');
          this.$forceUpdate();
          this.firstState = false;
          console.log('colData', this.colData);
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted: function mounted() {},
  methods: {
    openBox: function openBox(item) {
      item.show = !item.show;
      this.$forceUpdate();
    },
    // 分组全选
    onCheckAllChange: function onCheckAllChange(e, data, key) {
      var _this2 = this;

      this.checkAll[key] = e.target.checked; // 清空该分组选中的数组

      var selectCol = _toConsumableArray(this.selectCol);

      data.forEach(function (item) {
        if (_this2.selectCol.includes(item.value)) {
          selectCol.splice(selectCol.indexOf(item.value), 1);
        }
      }); // 如果当前复选框为选中状态 则代表该分组全选

      if (e.target.checked) {
        data.forEach(function (item) {
          selectCol.push(item.value);
        });
      }

      this.selectCol = _toConsumableArray(selectCol);
      this.$emit('onChange');
      this.$forceUpdate();
    },
    // 多选框组变动
    onChange: function onChange(item, key) {
      var _this3 = this;

      // 如果分组数组的每一项都包含在当前选中数组selectCol里面，则表示当前分组全选
      if (item.every(function (v) {
        if (_this3.selectCol.includes(v.value)) {
          return true;
        } else {
          return false;
        }
      })) {
        // 全选
        this.checkAll[key] = true;
      } else {
        this.checkAll[key] = false;
      }

      this.$emit('onChange');
      this.$forceUpdate();
    },
    onClose: function onClose() {
      this.visible = false;
    }
  }
};